import { AcquiringChannelFlags, CustomerTypes, JourneyType } from 'src/context/salesforce-context';
import { BUSINESS_TYPE_KEY_TO_NAME_LOOKUP } from 'src/helpers/constants';

export const getAcquiringChannels = (
  customerType,
  journeyType,
  businessType,
  isHideBuyOnlineDevices,
  noBuyInStoreDevicesExist,
  isVodapayChannel,
) => {
  /* if there are no buy in-store terminals configured in Salesforce, or
		 this is the vodapay journey, default journey type selection to buy
		 or rent online - fica online */
  const journeyTypeAdapted =
    noBuyInStoreDevicesExist || isVodapayChannel
      ? JourneyType.buyOrRentOnlineFicaOnline
      : journeyType;

  if (customerType && journeyTypeAdapted && businessType) {
    let solutionType = [];

    switch (journeyTypeAdapted) {
      case JourneyType.buyInStoreFicaOnline:
        solutionType.push(AcquiringChannelFlags.buyInstoreFicaOnline);
        break;

      case JourneyType.vodacomBusiness:
        solutionType.push(AcquiringChannelFlags.vodacomBusiness);
        break;

      case JourneyType.buyOrRentOnlineFicaOnline:
        const isCustomerAgent = customerType === CustomerTypes.agent;

        if (isCustomerAgent) {
          return [
            AcquiringChannelFlags.buyInstoreFicaOnline,
            AcquiringChannelFlags.rentOnlineFicaOnline,
            AcquiringChannelFlags.zeroRentOnlineFicaOnline,
          ];
        }

        if (!isVodapayChannel) {
          solutionType.push(AcquiringChannelFlags.rentOnlineFicaOnline);
          solutionType.push(AcquiringChannelFlags.zeroRentOnlineFicaOnline);
        }

        const isCustomerNormalType = customerType === CustomerTypes.normal;
        const isSovOfferedToBusinessType =
          businessType === BUSINESS_TYPE_KEY_TO_NAME_LOOKUP.sole_prop ||
          businessType === BUSINESS_TYPE_KEY_TO_NAME_LOOKUP.company;

        if (!isVodapayChannel && !isHideBuyOnlineDevices && isCustomerNormalType) {
          solutionType.push(AcquiringChannelFlags.buyOnlineFicaOnline);
        }

        if (isSovOfferedToBusinessType && isCustomerNormalType) {
          solutionType.push(AcquiringChannelFlags.vodapay);
        }
        break;
    }

    return solutionType;
  } else {
    return [];
  }
};
